/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const SortLink = styled.a<{ isDisabled: boolean }>(({ isDisabled }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  pointerEvents: isDisabled ? 'none' : 'initial',

  '&, &:hover, &:visited': {
    color: token('color.text.subtlest', colors.N300),
  },

  '&:hover': {
    textDecoration: 'underline',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
  },

  '&:focus': {
    outline: isDisabled
      ? 'none'
      : `${gridSize() / 4}px olid ${token(
          'color.border.disabled',
          colors.B100
        )}`,
  },
}));
